// extracted by mini-css-extract-plugin
module.exports = {"page":"RapidSeries_page__XfDCv"};